export default __webpack_public_path__ + "static/media/b0a16001a1e1decea8c31d8b48336a57.gif";